import type { Ref } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import type { ITableDataResponse, ITableState } from '@modules/tables/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import { keepPreviousData } from '@tanstack/vue-query';

import type { IAffiliatesPendingListItem } from '../types';
import {
  AFFILIATES_PENDING_LIST_QUERY_KEY,
  AFFILIATES_PENDING_LIST_URL,
  AFFILIATES_PENDING_PERMISSIONS,
} from '../constants';

export default function useAffiliatesPendingListQuery(
  tableState: Ref<ITableState>,
): IContextQueryResult<ITableDataResponse<IAffiliatesPendingListItem>> {
  const { fetchPost } = useRestClient();

  return useContextQuery<ITableDataResponse<IAffiliatesPendingListItem>>({
    queryKey: [AFFILIATES_PENDING_LIST_QUERY_KEY, tableState],
    queryFn: ({ signal }) => fetchPost<ITableDataResponse<IAffiliatesPendingListItem>>(
      AFFILIATES_PENDING_LIST_URL,
      tableState.value,
      {
        signal,
        permission: AFFILIATES_PENDING_PERMISSIONS.SHOW,
      },
    ),
    placeholderData: keepPreviousData,
  });
}
